<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        textField="nomeFantasia"
                        v-model="model.unidadeId"
                        valueField="id"
                    />
                </rkm-col>
    
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!model.unidadeId"
                        :options="data.form.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        textField="nome"
                        v-model="model.infraestruturaId"
                        valueField="id"
                    />
                </rkm-col>
            </rkm-row>
    
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!model.infraestruturaId"
                        :options="data.form.centrosCusto"
                        :validations="validations.centroCusto"
                        label="Setor"
                        show-default-option
                        textField="setorNome"
                        v-model="model.centroCustoId"
                        valueField="id"
                    />
                </rkm-col>
    
                <rkm-col cols="auto">
                    <rkm-button
                        color="primary"
                        :label="false"
                        @click="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="data.model.centrosCusto"
            class="mt-3"
        >
            <template v-slot:cell(actions)="{ index }">
                <rkm-button
                    @click.stop="remove(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                centroCusto: { required: true },
            }
        },
        fields() {

        return [
                {
                    key: 'unidadeNomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'localAtendimentoNome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'setorNome',
                    label: 'Setor',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao')
        }
    },
    data: () => ({
        model: {
            unidadeId: null,
            infraestruturaId: null,
            centroCustoId: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadInfraestrutura() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                origem: 'controle-estoque',
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => this.data.form.infraestruturas = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadCentrosCusto() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                origem: 'controle-estoque',
                listar: 'centros-custo',
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => this.data.form.centrosCusto = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        add() {

            const centroCustoJaIncluido = this.data.model.centrosCusto
                .find(cc => cc.id === this.model.centroCustoId)

            if (centroCustoJaIncluido) {

                this.showValidationNotification('Este centro de custo já foi incluído.')

                return;
            }

            this.data.model.centrosCusto.push({
                id: this.model.centroCustoId,
                unidadeNomeFantasia: this.data.form.unidades.find(u => u.id === this.model.unidadeId).nomeFantasia,
                localAtendimentoNome: this.data.form.infraestruturas.find(i => i.id === this.model.infraestruturaId).nome,
                setorNome: this.data.form.centrosCusto.find(cc => cc.id === this.model.centroCustoId).setorNome,
                grupos: [],
                isSaved: false,
            })

            this.resetForm()
        },
        remove(index) {
            this.data.model.centroCusto = this.data.model.centroCusto.splice(index, 1)
        },
        resetForm() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.centroCustoId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'data.form.infraestruturas'(infraestruturas) {

            if (infraestruturas.length === 1) {

                this.model.infraestruturaId = infraestruturas[0].id
            }
        },
        'data.form.centrosCusto'(centrosCusto) {

            if (centrosCusto.length === 1) {

                this.model.centroCustoId = centrosCusto[0].id
            }
        },
        'model.unidadeId'(unidadeId) {

            this.model.infraestruturaId = null

            if (unidadeId) {

                this.loadInfraestrutura()
            }
        },
        'model.infraestruturaId'(infraestruturaId) {

            this.model.centroCustoId = null

            if (infraestruturaId) {

                this.loadCentrosCusto()
            }
        },
    }
}
</script>